// extracted by mini-css-extract-plugin
export default {"gridContainer":"VariantGrid_gridContainer__Q7rmR","gridContainerPlaceholder":"VariantGrid_gridContainerPlaceholder__c0me3"};